export function isBlobUrl(url: string): boolean {
  return url.indexOf('blob') === 0;
}
